import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { getTimeStamp } from '../../webcommon/common/helpers';

export const INITIAL_STATE = {
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    runDate: '',
    dateFrom: '',
    dateTo: '',
    initialisedDailyBatchHist: false,
    loadingDailyBatchHist: false,
    loadError:false,
    loadSuccess:false,
    currentServerFilters: null,
    rowsPreview: [],
    rows: [],
    lastUpdatedDailyBatchHist: getTimeStamp(),
    gridSorting: [{ gridId: 'timestampSort', gridSort: [{ id: 'businessDate', desc: true }] }],
    selectedRunId: null,
    runDetail: null,
    loadingRunDetail: false,
};
const setRunDate = fp.set('runDate');
const setDateFrom = fp.set('dateFrom');
const setDateTo = fp.set('dateTo');
const setDailyBatchHistInitialised = fp.set('initialisedDailyBatchHist');
const setDailyBatchHistLoading = fp.set('loadingDailyBatchHist');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_RUNDATE:
            return setRunDate(action.date, state);     
        case actions.SET_DATE_FROM:
            return setDateFrom(action.date, state);  
        case actions.SET_DATE_TO:
            return setDateTo(action.date, state);     
        case actions.SET_DAILY_BATCH_HIST_INITIALISED:
            return setDailyBatchHistInitialised(action.initialised, state);
        case actions.SET_DAILY_BATCH_HIST_LOADING:
            return setDailyBatchHistLoading(action.loading, state);     
        case actions.GET_DAILY_BATCH_HIST_SUCCESS:{
            return {
                ...state,
                rows: action.result,
                lastUpdatedDailyBatchHist: getTimeStamp()
            };
        }
        case actions.SELECT_RUN:
            return { ...state, selectedRunId: action.runId, runDetail: null, loadingRunDetail: true };
        case actions.DESELECT_RUN:
            return { ...state, selectedRunId: null, runDetail: null, loadingRunDetail: false };
        case actions.GET_RUN_STATUS_SUCCESS:
            return { ...state, runDetail: action.detail, loadingRunDetail: false };
        case actions.GET_RUN_STATUS_FAILED:
            return { ...state, loadingRunDetail: false, selectedRunId: null };
        default:
            return state;
    }
}
